var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.812 0c-8.763 0-15.812 7.091-15.812 15.908 0 7.858 5.525 14.183 12.954 15.716v-11.116h-3.239v-4.216h3.239v-3.45c0-1.342 0.381-5.558 5.334-5.558h4v4.216h-2.857c-0.572 0-1.334 0.383-1.334 1.533v3.067h4.191l-0.381 4.408h-3.81v11.116c7.62-1.15 13.526-7.666 13.526-15.716 0-8.816-7.049-15.908-15.812-15.908z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.260fa49d3ca1ca52752d2de25f2cb563.svg";
export { ForwardRef as ReactComponent };